import { render, staticRenderFns } from "./Protocolo.vue?vue&type=template&id=40b68f38&scoped=true"
import script from "./Protocolo.vue?vue&type=script&lang=js"
export * from "./Protocolo.vue?vue&type=script&lang=js"
import style0 from "./Protocolo.vue?vue&type=style&index=0&id=40b68f38&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b68f38",
  null
  
)

export default component.exports